module.exports = __webpack_public_path__ + "static/media/franchising-placeholder.6d0fc881.webp";